import { MetricCard, MetricGrid } from "@nymbl/nos2-rules";
import { WEEK_HOURS } from "@/lib/time/constants";
import { formatHours } from "@/lib/time/rules";

/** Where the shown week sits against today: only a week that has ended can be short on hours. */
export type WeekPhase = "past" | "current" | "future";

interface WeekCardsProps {
  phase: WeekPhase;
  weekTotal: number;
  ptoTotal: number;
  onTimePct: number | null;
}

/**
 * Logged this week always (it is the week's progress); Missing and Time off only above 0, and
 * Missing never for a future week and red only once the week has ended (UI standard 7);
 * on-time only once a sign-off is due (UI standard 7: no tiles that read 0).
 */
export function WeekCards({ phase, weekTotal, ptoTotal, onTimePct }: WeekCardsProps) {
  const missing = Math.max(0, WEEK_HOURS - weekTotal);
  return (
    <MetricGrid>
      <MetricCard
        label="Logged this week"
        value={formatHours(weekTotal)}
        detail={`of ${WEEK_HOURS} hrs`}
        target={{
          ratio: Math.min(weekTotal / WEEK_HOURS, 1),
          label: `${formatHours(weekTotal)} of ${WEEK_HOURS} hrs`,
        }}
      />
      {missing > 0 && phase !== "future" && (
        <MetricCard
          label="Missing"
          value={formatHours(missing)}
          detail="hrs"
          alert={phase === "past"}
        />
      )}
      {ptoTotal > 0 && <MetricCard label="Time off" value={formatHours(ptoTotal)} detail="hrs" />}
      {onTimePct !== null && (
        <MetricCard label="On-time sign-off" value={`${onTimePct}%`} detail="this year" />
      )}
    </MetricGrid>
  );
}
